import type { Sponsor } from '@/types'

function fallbackSponsorClientId() {
  return `sponsor-${Math.random().toString(36).slice(2, 10)}`
}

export function createSponsorClientId() {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : fallbackSponsorClientId()
}

export function withSponsorClientId(sponsor: Sponsor): Sponsor {
  return sponsor.client_id ? sponsor : { ...sponsor, client_id: createSponsorClientId() }
}

export function serializeSponsor(sponsor: Sponsor) {
  const { client_id: _clientId, logo_url: _logoUrl, ...submittedSponsor } = sponsor
  return submittedSponsor
}
